import { type IPromo } from '../../../types/promos';

export function getAuthorName(promo: IPromo): string | null | undefined {
  const cianMortgage = promo.promoType === 'cianMortgage';

  return cianMortgage ? 'Циан.Ипотека' : promo.authorName;
}
